export const updateStatusInitialState = {
  caseID: "",
  appointmentID: "",
  status: 0,
  bmcFeedback: "",
  onHoldReasonID: null,
  maintenanceReport: {
    fileName: "",
    fileExtension: "",
    fileBase64: "",
    subject: "",
  }
}